import { useRouterState } from "@tanstack/react-router";
import { formatReviewedDate, lastmodFor } from "@/lib/route-lastmod";

interface LastUpdatedProps {
  /** Override the date (YYYY-MM-DD). Defaults to the current route's content date. */
  date?: string;
  /** Spanish label, for /es pages. */
  lang?: "en" | "es";
  className?: string;
  /** Only the shared shell renders the date, so legacy placements cannot duplicate it. */
  fallback?: boolean;
}


/**
 * Visible "Last updated" line. Uses the same page-specific content date the
 * sitemap publishes as <lastmod>, so what readers see matches what crawlers get.
 */
export function LastUpdated({ date, lang, className = "", fallback = false }: LastUpdatedProps) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const clean = pathname.replace(/\/$/, "") || "/";
  if (/^\/(admin|api|dev|auth|login|logout|__|~)(\/|$)/.test(clean) || clean.includes("preview")) return null;
  if (!fallback) return null;
  const language = lang ?? (clean === "/es" || clean.startsWith("/es/") ? "es" : "en");
  const iso = date ?? lastmodFor(pathname);
  if (!iso) return null;

  return (
    <p className={`text-sm text-muted-foreground ${className}`.trim()}>
      {language === "es" ? "Última revisión y edición: " : "Last reviewed and edited on: "}
      <time dateTime={iso}>{formatReviewedDate(iso, language)}</time>.
    </p>
  );
}

export default LastUpdated;
